<template>
    <Link v-if="group" :href="route('groups.view', group.tra_id)" class="text-blue-600">
        {{ group.title }}
    </Link>

    <span v-else-if="contacts && contacts.length">
        <span v-for="(contact, index) in contacts" :key="contact.id">
            <Link :href="route('contacts.view', contact.id)" class="text-blue-600">{{ contact.full_name }}</Link><span v-if="index < contacts.length - 1">, </span>
        </span>
    </span>
    
    <span v-else>{{ data.recipient_name }}</span>
</template>

<script>
export default {
    name: "MessageDeliverableTableName",
    props: {
        meta: {
            type: Object,
            default: () => { }
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => { }
        }
    },
    components: { },
    data() {
        return {};
    },
    methods: {},
    computed: {
        group() {
            return this.data.group;
        },
        contacts() {
            return this.data.contacts;
        }
    },
    
};
</script>

<style scoped></style>
